import { type ReactNode, type ReactElement } from 'react'
import type { IdlePolicyMinutes, SessionIdleNamespaces } from './types'
import { SessionIdleTimerEngine } from './SessionIdleTimerEngine'

export interface SessionIdleCountdownProviderProps {
  children: ReactNode
  namespaces: SessionIdleNamespaces
  /** When null, idle timeout UI and timer are disabled. */
  idlePolicy: IdlePolicyMinutes | null
  onIdleLogout: () => void | Promise<void>
  /**
   * When true, idle countdown and idle logout are suspended (e.g. active CTI call).
   * Timer resets from full duration after this becomes false again.
   */
  ctiCallActive?: boolean
}

export function SessionIdleCountdownProvider({
  children,
  namespaces,
  idlePolicy,
  onIdleLogout,
  ctiCallActive,
}: SessionIdleCountdownProviderProps): ReactElement {
  return (
    <>
      {children}
      <SessionIdleTimerEngine
        namespaces={namespaces}
        idlePolicy={idlePolicy}
        onIdleLogout={onIdleLogout}
        ctiCallActive={ctiCallActive}
      />
    </>
  )
}
